module.exports = __webpack_public_path__ + "img/85.3995d051.jpg";